﻿
import { FormBuilder } from "@tulipinfo/tue";
import { encrypt } from "./shared/utils/encrypt";


const fb = new FormBuilder();
const form = fb.createForm('#pwd-login-form');

window.onload = () => {
    initPwdLogin();
    setIAgreeValueChange();
    loginClickListener();
    const privacyAgreement = new PrivacyAgreement();
}
const initPwdLogin = () => {
    fb.createForm('#pwd-login-form');
    const menuEl = window.document.getElementById('dropdown-menu-lang');
    const aEles = menuEl.querySelectorAll('.t-href');
    const baseAddress = (<HTMLInputElement>document.querySelector('#GLOBAL_API_BASEADDRESS')).value;
    if (menuEl != null && aEles != null && aEles.length > 0) {
        aEles.forEach((child: any) => {
            const value = child.getAttribute('t-value');
            child.href = `${baseAddress}/SetLanguage?culture=${value}&returnUrl=${encodeURIComponent(location.href)}`;
        });
    }
}

const setIAgreeValueChange = () => {
    const ele = window.document.getElementById('l-iAgree');
    ele && ele.addEventListener('change', (event: any) => {
        const checked = event.target.checked;
        const btnLoginEle = window.document.getElementById('l-login');
        btnLoginEle && (btnLoginEle["disabled"] = !checked);
    })
};
const encryptNamePwd =() => {
    //const encryptName = encrypt(form.get('PasswordLoginData.LoginName').value)
    //form.get('PasswordLoginData.LoginName').value = encryptName;
    const encryptPassword = encrypt(form.get('PasswordLoginData.Password').value)
    form.get('PasswordLoginData.Password').value = encryptPassword;
    return true;
}
const loginClickListener = () => {

    const loginBtn = document.getElementById('l-login');
    console.log(loginBtn);
    if (loginBtn) {
        loginBtn.addEventListener('click', (event) => {
            // 阻止默认的表单提交
            event.preventDefault();

            // 执行加密并提交
            if (encryptNamePwd()) {
                // 获取表单元素并提交
                const loginForm = document.getElementById('pwd-login-form') as HTMLFormElement;
                if (loginForm) {
                    loginForm.submit();
                }
            }
        });
    }
}

class PrivacyAgreement {
    privacyAgreementEle: HTMLElement | undefined;
    rejectAllEle: HTMLElement | undefined;
    acceptAllCookiesEle: HTMLElement | undefined;
    lIAgreeEle: HTMLInputElement | undefined;
    privacyGreementVersionNumEle: HTMLInputElement | undefined;
    ls_privacyAgreemen = "privacyAccepted"; 
    _privacyagreementversionnumber = 'privacyagreementversionnumber';

    constructor() {
        this.lIAgreeEle = window.document.getElementById('l-iAgree') as HTMLInputElement;
        this.privacyAgreementEle = window.document.getElementById('privacyAgreement-content');
        this.rejectAllEle = window.document.getElementById('btn-rejectAll');
        this.acceptAllCookiesEle = window.document.getElementById('btn-acceptAllCookies');
        this.privacyGreementVersionNumEle = window.document.getElementById('privacyGreementVersionNum') as HTMLInputElement;
        if (!this.privacyAgreementEle || !this.rejectAllEle || !this.acceptAllCookiesEle || !this.lIAgreeEle || !this.privacyGreementVersionNumEle) return;
        //
        this.isShow();
        this.rejectAllEle.addEventListener('click', () => {
            this.isPrivacyAgreemen = false;
            this.privacyAgreementEle.style.display = 'none';
            this.changeIAgreeEle(this.isPrivacyAgreemen);
            this.uploadVersion();
        });
        this.acceptAllCookiesEle.addEventListener('click', () => {
            this.isPrivacyAgreemen = true;
            this.lIAgreeEle["disabled"] = false;
            this.privacyAgreementEle.style.display = 'none';
            this.changeIAgreeEle(this.isPrivacyAgreemen);
            this.uploadVersion();
        });
    }

    isShow() {
        const reject = () => {
            this.lIAgreeEle["disabled"] = true;
            this.privacyAgreementEle.style.display = 'flex';
        };
        // 不是最新版本/未同意都需要显示弹窗
       (!this.IslatestVersion || !this.isPrivacyAgreemen) && reject();
        this.changeIAgreeEle((this.IslatestVersion && this.isPrivacyAgreemen));
    }

    changeIAgreeEle(value: boolean) {
        this.lIAgreeEle.checked = value;
        const changeEvent = new Event('change');
        this.lIAgreeEle.dispatchEvent(changeEvent);
    }

    get isPrivacyAgreemen(): boolean {
        const isPrivacyAccepted = localStorage.getItem(this.ls_privacyAgreemen);
        return isPrivacyAccepted && isPrivacyAccepted === 'true';
    }

    set isPrivacyAgreemen(value: boolean) {
        localStorage.setItem(this.ls_privacyAgreemen, value ? 'true' : 'false');
    }

    get IslatestVersion(): boolean {
        const storage_version = localStorage.getItem(this._privacyagreementversionnumber);
        const latest_version = this.privacyGreementVersionNumEle.value;
        return storage_version && storage_version != '' && latest_version && latest_version != '' && storage_version == latest_version;
    }

    uploadVersion() {
        const latest_version = this.privacyGreementVersionNumEle.value;
        localStorage.setItem(this._privacyagreementversionnumber, latest_version);
    }
}